import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { EnrichmentTabsService } from '../enrichmentTabs.service';

@Component({
  selector: 'app-template-as-enrichment',
  templateUrl: './template-as-enrichment.component.html',
  styleUrls: ['./template-as-enrichment.component.css']
})
export class TemplateAsEnrichmentComponent implements OnInit {

  @Input() templateAsEnrichmentObj: any;
  @Input() parent: string;
  @Output() globalServicesCallBack: EventEmitter<any> = new EventEmitter<any>();
  public availableTemplates;
  public selectedThumbs = [];
  public noTemplatesFound: boolean = false;

  constructor(private pouchService: EnrichmentTabsService, private cdr: ChangeDetectorRef) { }

  ngOnInit() {
    var ref = this;
    this.pouchService.getTemplates(this).then(function (res) {
      if (res) {
        ref.availableTemplates = res;
        for (var i = 0; i <= ref.availableTemplates.length; i++) {
          if (ref.availableTemplates[i]) {
            ref.availableTemplates[i].isThumbActive = false;
          }
        }
      }
      else {
        ref.noTemplatesFound = true;
      }
      ref.cdr.detectChanges();
    });
  }

  onTemplateClick(thumb) {

    thumb.isThumbActive = !thumb.isThumbActive;

    if (this.parent == "newFolderPopup") {
      if (this.selectedThumbs[0]) {
        this.selectedThumbs[0].isThumbActive = false;
      }
      this.selectedThumbs = [];
      if (thumb.isThumbActive) {
        this.selectedThumbs.push(thumb);
      }
    }
    else {
      if (thumb.isThumbActive) {
        this.selectedThumbs.push(thumb);
      }
      else {
        var indOfThumb = this.selectedThumbs.findIndex(x => x.url == thumb.url);
        if (indOfThumb != -1) {
          this.selectedThumbs.splice(indOfThumb, 1);
        }
      }
    }

  }

  hideTemplateAsEnrichmentDialog(evt) {
    if (evt) {
      evt.stopPropagation();
    }
    else {
      this.templateAsEnrichmentObj.showPopup = false;
    }
  }

  addAsTab() {

    var obj = {
      "type": "template",
      "selectedThumbs": this.selectedThumbs
    }
    if (this.selectedThumbs.length) {
      this.globalServicesCallBack.emit(obj);
      this.hideTemplateAsEnrichmentDialog(undefined);
    }

  }
}



// WEBPACK FOOTER //
// ./src/app/bookShared/enrichmentTabs/template-as-enrichment/template-as-enrichment.component.ts